// extracted by mini-css-extract-plugin
export default {"btn":"BtnHover_btn__p0FEZ","pulse":"BtnHover_pulse__f9t-D","pulse-animation":"BtnHover_pulse-animation__EYTcY"};